import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  toString1pkumu07cwy4m as toString,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  RuntimeException1r3t0zl97011n as RuntimeException,
  VOID7hggqo3abtya as VOID,
  captureStack1fzi4aczwc4hg as captureStack,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instanceat14thlj150z as Unit_instance,
  ArrayList3it5z8td81qkl as ArrayList,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  toString30pk9tzaqopn as toString_0,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  get6d5x931vk0s as get,
  protoOf180f3jzyo7rfj as protoOf,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Companion {}
class RequestContext {
  constructor(initialClazz) {
    this.o61_1 = initialClazz;
  }
  toString() {
    return 'RequestContext(initialClazz=' + toString(this.o61_1) + ')';
  }
  hashCode() {
    return this.o61_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RequestContext))
      return false;
    var tmp0_other_with_cast = other instanceof RequestContext ? other : THROW_CCE();
    if (!this.o61_1.equals(tmp0_other_with_cast.o61_1))
      return false;
    return true;
  }
}
class NotMappedException extends RuntimeException {
  static w61(clazz, requestedByClass, ctx, msg) {
    msg = msg === VOID ? 'Not mapped ' + toString(clazz) + ' requested by ' + toString(requestedByClass) + ' in ' + ctx.toString() : msg;
    var $this = this.ia(msg);
    captureStack($this, $this.v61_1);
    $this.r61_1 = clazz;
    $this.s61_1 = requestedByClass;
    $this.t61_1 = ctx;
    $this.u61_1 = msg;
    return $this;
  }
}
class Injector {
  constructor(parent, level) {
    parent = parent === VOID ? null : parent;
    level = level === VOID ? 0 : level;
    this.x61_1 = parent;
    this.y61_1 = level;
    this.z61_1 = null;
    this.a62_1 = LinkedHashMap.ac();
    var tmp = this;
    var tmp3_safe_receiver = this.x61_1;
    var tmp0_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.b62_1;
    tmp.b62_1 = tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs;
    this.d62(getKClass(Injector), this);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.c62_1 = ArrayList.i1();
  }
  e62() {
    var tmp0_elvis_lhs = this.z61_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp4_safe_receiver = this.x61_1;
      tmp = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.z61_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  f62() {
    return new Injector(this, this.y61_1 + 1 | 0);
  }
  d62(clazz, instance) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.inject.Injector.mapInstance.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.a62_1;
    var value = new InstanceObjectProvider(instance);
    this_0.f3(clazz, value);
    return this;
  }
  g62(clazz, gen) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.inject.Injector.mapSingleton.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.a62_1;
    var value = new SingletonObjectProvider(gen);
    this_0.f3(clazz, value);
    return this;
  }
  h62(clazz, gen) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.inject.Injector.mapPrototype.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.a62_1;
    var value = new PrototypeObjectProvider(gen);
    this_0.f3(clazz, value);
    return this;
  }
  i62(clazz, ctx) {
    var tmp0_elvis_lhs = this.a62_1.d3(clazz);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp7_safe_receiver = this.x61_1;
      tmp = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.i62(clazz, ctx);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp8_safe_receiver = this.e62();
      var tmp9_safe_receiver = tmp8_safe_receiver == null ? null : tmp8_safe_receiver(clazz, ctx);
      var tmp_1;
      if (tmp9_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.inject.Injector.getProviderOrNull.<anonymous>' call
        // Inline function 'kotlin.collections.set' call
        this.a62_1.f3(clazz, tmp9_safe_receiver);
        tmp_1 = tmp9_safe_receiver;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var tmp_2 = tmp_0;
    return (tmp_2 == null ? true : isInterface(tmp_2, ObjectProvider)) ? tmp_2 : null;
  }
  j62(clazz, ctx) {
    var tmp0_elvis_lhs = this.i62(clazz, ctx);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw NotMappedException.w61(clazz, ctx.o61_1, ctx, "Class '" + toString(clazz) + "' doesn't have constructors " + ctx.toString());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  k62(clazz, ctx) {
    return this.j62(clazz, ctx).l62(this);
  }
  m62(clazz, ctx, $super) {
    ctx = ctx === VOID ? new RequestContext(clazz) : ctx;
    return $super === VOID ? this.k62(clazz, ctx) : $super.k62.call(this, clazz, ctx);
  }
  toString() {
    return 'Injector(level=' + this.y61_1 + ')';
  }
  n62(instance) {
    if (!(instance == null) ? isInterface(instance, InjectorDependency) : false) {
      instance.o62(this);
    }
    if (!(instance == null) ? isInterface(instance, InjectorDestructor) : false) {
      this.c62_1.h(instance);
    }
    return instance;
  }
  p62() {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.a62_1.m1().a1();
    while (_iterator__ex2g4s.b1()) {
      var pair = _iterator__ex2g4s.c1();
      pair.o1().p62();
    }
    var _iterator__ex2g4s_0 = this.c62_1.a1();
    while (_iterator__ex2g4s_0.b1()) {
      var deinit = _iterator__ex2g4s_0.c1();
      deinit.p62();
    }
    this.c62_1.y2();
  }
}
class InjectorDependency {}
class ObjectProvider {}
class InstanceObjectProvider {
  constructor(instance) {
    this.q62_1 = instance;
  }
  l62(injector) {
    return this.q62_1;
  }
  p62() {
    var tmp = this.q62_1;
    var tmp1_safe_receiver = (tmp == null ? true : isInterface(tmp, InjectorDestructor)) ? tmp : null;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p62();
    }
  }
  toString() {
    return 'InstanceObjectProvider(' + toString_0(this.q62_1) + ')';
  }
}
class SingletonObjectProvider {
  constructor(generator) {
    this.r62_1 = generator;
    this.s62_1 = null;
  }
  l62(injector) {
    if (this.s62_1 == null)
      this.s62_1 = injector.n62(this.r62_1(injector));
    return ensureNotNull(this.s62_1);
  }
  p62() {
    var tmp = this.s62_1;
    var tmp0_safe_receiver = (tmp == null ? true : isInterface(tmp, InjectorDestructor)) ? tmp : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p62();
    }
  }
  toString() {
    return 'SingletonObjectProvider(' + toString_0(this.s62_1) + ')';
  }
}
class PrototypeObjectProvider {
  constructor(generator) {
    this.t62_1 = generator;
  }
  l62(injector) {
    return injector.n62(this.t62_1(injector));
  }
  p62() {
    return Unit_instance;
  }
  toString() {
    return 'PrototypeObjectProvider()';
  }
}
class InjectorDestructor {}
class Companion_0 {}
class InjectorContext {
  constructor(injector) {
    this.u62_1 = injector;
  }
  n1() {
    return Companion_instance_0;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function injector($completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp11_safe_receiver = $completion.lc().yc(Companion_instance_0);
  var tmp0_elvis_lhs = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.u62_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = 'Injector not in the context, please call withInjector function';
    throw IllegalStateException.s4(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(RequestContext, 'RequestContext');
initMetadataForClass(NotMappedException, 'NotMappedException');
initMetadataForClass(Injector, 'Injector', Injector);
initMetadataForInterface(InjectorDependency, 'InjectorDependency');
initMetadataForInterface(ObjectProvider, 'ObjectProvider');
initMetadataForClass(InstanceObjectProvider, 'InstanceObjectProvider', VOID, VOID, [ObjectProvider]);
initMetadataForClass(SingletonObjectProvider, 'SingletonObjectProvider', VOID, VOID, [ObjectProvider]);
initMetadataForClass(PrototypeObjectProvider, 'PrototypeObjectProvider', VOID, VOID, [ObjectProvider]);
initMetadataForInterface(InjectorDestructor, 'InjectorDestructor');
initMetadataForCompanion(Companion_0);
protoOf(InjectorContext).yc = get;
protoOf(InjectorContext).pm = fold;
protoOf(InjectorContext).om = minusKey;
protoOf(InjectorContext).qm = plus;
initMetadataForClass(InjectorContext, 'InjectorContext', VOID, VOID, [Element]);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
//endregion
//region block: exports
export {
  injector as injectorznx5rgygah7n,
  InjectorContext as InjectorContextps0ngmjb9onz,
  InjectorDependency as InjectorDependency2f8dsqe1kn3nn,
  Injector as Injectorxjyp19tp5mfu,
};
//endregion
